import { login, getProfile } from '@/api/admin'

const state = {
  token: localStorage.getItem('admin_token') || '',
  userInfo: JSON.parse(localStorage.getItem('admin_userInfo') || '{}')
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('admin_token', token)
  },
  
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    localStorage.setItem('admin_userInfo', JSON.stringify(userInfo))
  },
  
  CLEAR_USER_DATA(state) {
    state.token = ''
    state.userInfo = {}
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_userInfo')
  }
}

const actions = {
  // 登录
  async login({ commit }, loginForm) {
    try {
      const response = await login(loginForm)
      const { token, admin } = response.data
      
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', admin)
      
      return response
    } catch (error) {
      throw error
    }
  },
  
  // 获取用户信息
  async getProfile({ commit }) {
    try {
      const response = await getProfile()
      commit('SET_USER_INFO', response.data)
      return response
    } catch (error) {
      throw error
    }
  },
  
  // 登出
  logout({ commit }) {
    commit('CLEAR_USER_DATA')
    return Promise.resolve()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
